<template>
  <div class="page-modal">
    <widgetModal title="Assign Contact Owner" subtitle="Select contact owners to assign to the selected contacts"
      btnlefttext="Save Changes" btncentertext="Cancel" :leftloading="saving_loading" :centerloading="false"
      :hiderightbtn="true" :footerhidden="false" footer_padding="10px 18px 30px 30px" header_padding="30px 0px 0px 31px"
      body_padding="0px 30px" width="500px" @onLeftClick="submitContactOwners()" @onCenterClick="onCancel"
      :loading="isLoadingData">
      <div class="widget-modal-body-noscoll">
        <div class="row">
          <widgetInputWrapper title="Contact Owner">
            <searchSelectInput url="/company/search/manager" :miltiple="true" type="site" v-model="assigned"
              placeholder="Search contact owner">
              <template v-slot:result="{ result }">
                <span class="search-contact-item">
                  <img width="20" v-if="result.profile_picture"
                    :src="$fullUrl('images/profiles/' + result.profile_picture)" />
                  <img v-else width="20" src="@/assets/avatar.png" />
                  {{ result.first_name | validate }}
                  {{ result.last_name | validate }}
                </span>
              </template>
              <template v-slot:selected="{ selected }">
                <span v-if="selected" class="selected-search-contact-item">
                  <img width="20" v-if="selected.profile_picture"
                    :src="$fullUrl('images/profiles/' + selected.profile_picture)" />
                  <img v-else width="20" src="@/assets/avatar.png" />
                  {{ selected.first_name | validate }}
                </span>
              </template>
            </searchSelectInput>
          </widgetInputWrapper>
        </div>
      </div>
    </widgetModal>
  </div>
</template>
<script>
export default {
  name: "assign-contact-owner-modal",
  props: {
    selectedContactIds: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  data() {
    return {
      assigned: {
        added: [],
        removed: []
      },
      saving_loading: false,
      isLoadingData: false
    };
  },
  methods: {
    submitContactOwners() {
      let vm = this;

      if (vm.assigned.added.length === 0) {
        vm.$notify({
          group: "status",
          title: "Warning",
          text: "Please select at least one contact owner",
          type: "warn",
          duration: 3000,
        });
        return;
      }

      let form_data = new FormData();
      let company_id = vm.$getLoggedUser().company_id;
      form_data.append("crm_company_id", company_id);

      // Add the selected contact IDs
      form_data.append("contact_ids", JSON.stringify(vm.selectedContactIds));

      // Add the contact owners
      form_data.append("contact_owners", JSON.stringify(vm.assigned.added));

      vm.saving_loading = true;
      vm.$store
        .dispatch("ACCOUNT_UPDATE_CONTACT_OWNERS", form_data)
        .then((response) => {
          vm.saving_loading = false;
          vm.$notify({
            group: "status",
            title: "Success",
            text: "Contact owners successfully assigned",
            type: "success",
            duration: 3000,
          });
          vm.$emit("success", response.data);
        })
        .catch((error) => {
          console.error({ error });
          vm.saving_loading = false;
          vm.$notify({
            group: "status",
            title: "Error",
            text: "Something went wrong, please try again",
            type: "error",
            duration: 3000,
          });
        });
    },
    onCancel() {
      let vm = this;
      vm.$emit("close", null);
    }
  }
};
</script>

<style lang="scss" scoped>
$assets: "~@/assets";

.page-modal {
  .widget-modal-body-noscoll {
    position: relative;

    .top-floating-option {
      position: absolute;
      top: -53px;
      right: 0px;
      display: flex;
      align-items: center;
    }
  }
}
</style>